import React, { FunctionComponent } from 'react';
import { pathOr } from 'ramda';

import TransactionsChart from 'components/TransactionsChart';
import {
  CNTransactions,
  Transactions,
} from 'components/TransactionsChart/TransactionsChart.helpers';
import { ChartPlaceholder } from 'components/Placeholder';
import Query from 'components/Query';

import Header from 'scenes/NetworkHealth/components/Header';
import GET_GENERAL_EVENTS from './GeneralEventsSection.queries';

type Props = {
  startDate: string;
  endDate: string;
};

type QueryResponse = {
  data: {
    authsThatFailedToClearByMarketplace: CNTransactions;
    dailyFulfillmentsByMarketplace: CNTransactions;
  };
  loading?: boolean;
};

const renderHeader = (title: string, logo?: string) => {
  return <Header src={logo} content={title} />;
};

const renderGeneralEventsSection = (startDate: string, endDate: string) => (
  response: QueryResponse,
) => {
  const authsThatFailedToClearByMarketplace = pathOr(
    [],
    ['data', 'authsThatFailedToClearByMarketplace', 'DOSH'],
    response,
  ) as Transactions;

  const dailyFulfillmentsByMarketplace = pathOr(
    [],
    ['data', 'dailyFulfillmentsByMarketplace', 'DOSH'],
    response,
  ) as Transactions;

  if (response.loading) {
    return (
      <>
        <ChartPlaceholder />
        <ChartPlaceholder />
      </>
    );
  }

  return (
    <>
      <TransactionsChart
        header={renderHeader('Fulfillments')}
        transactions={dailyFulfillmentsByMarketplace}
        parameters={{
          startDate,
          endDate,
        }}
      />

      <TransactionsChart
        header={renderHeader('Clear Failures')}
        transactions={authsThatFailedToClearByMarketplace}
        parameters={{
          startDate,
          endDate,
        }}
      />
    </>
  );
};

const GeneralEventsSection: FunctionComponent<Props> = ({
  startDate,
  endDate,
}) => (
  <Query
    enableProgressInfo
    query={GET_GENERAL_EVENTS}
    render={renderGeneralEventsSection(startDate, endDate)}
    variables={{
      params: {
        startDate,
        endDate,
        marketplace: 'DOSH',
      },
    }}
  />
);

export default GeneralEventsSection;
